<template>
    <div class="container pt-2">
        <PageTitle main="Rastreio" sub=""/>
        <b-form v-if="inSearch">
            <div class="row justify-content-md-center">
                <div class="col-md-6">
                    <b-form-group label="Código de Rastreio:" label-for="rastreio-codigo">
                        <b-form-input id="rastreio-codigo" type="text"
                            v-model="codigo" required
                            placeholder="Informe o código de rastreio."
                            :class="{ 'inputError': $v.codigo.$error }"
                            class="textInput"
                            @keydown.tab="$v.codigo.$touch"/>
                        <span class="error" v-if="!$v.codigo.required && $v.codigo.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-6 mt-4">
                    <b-button variant="outline-success" class="ml-2 botaoInput" @click="loadStatuses">Pesquisar</b-button>
                    <b-button variant="outline-danger" class="ml-2 botaoInput" @click="reset">Limpar</b-button>
                </div>
            </div>
            <hr>
        </b-form>
        <div v-if="image">
            <b-img class="mt-2" id="foto" :src="image" fluid alt="Rastreio da Carga" @click="popOver($event)"></b-img>
            <hr>
            <b-alert
                :show="dismissCountDown"
                dismissible
                :variant="variantAlert"
                @dismissed="dismissCountDown=0"
                @dismiss-count-down="countDownChanged">
            <p class="text-center">{{ textNotify }}</p>
            </b-alert>
            <b-form>
                <div class="row">
                    <div class="col-md-2">
                        <b-form-group label="Nome da Origem:" label-for="dataRastreio-origem-nome" id="lbl-origem_nome">
                            <b-form-input id="dataRastreio-origem_nome" type="text"
                                v-model="dataRastreio[0].origem_nome" disabled
                                class="textInput"/>
                        </b-form-group>
                    </div>
                    <div class="col-md-4">
                        <b-form-group label="Endereço da Origem:" label-for="dataRastreio-origem-endereco" id="lbl-origem_end">
                            <b-form-input id="dataRastreio-origem_end" type="text"
                                v-model="dataRastreio[0].origem_end" disabled
                                class="textInput"/>
                        </b-form-group>
                    </div>
                    <div class="col-md-2">
                        <b-form-group label="Nome da Destino:" label-for="dataRastreio-destino-nome" id="lbl-destino_nome">
                            <b-form-input id="dataRastreio-destino_nome" type="text"
                                v-model="dataRastreio[0].destino_nome" disabled
                                class="textInput"/>
                        </b-form-group>
                    </div>
                    <div class="col-md-4">
                        <b-form-group label="Endereço da Destino:" label-for="dataRastreio-destino-endereco" id="lbl-destino_end">
                            <b-form-input id="dataRastreio-destino_end" type="text"
                                v-model="dataRastreio[0].destino_end" disabled
                                class="textInput"/>
                        </b-form-group>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <b-form-group label="Nome do Motorista:" label-for="dataRastreio-motorista-nome" id="lbl-motorista_nome">
                            <b-form-input id="dataRastreio-motorista_nome" type="text"
                                v-model="dataRastreio[0].motorista_nome" disabled
                                class="textInput"/>
                        </b-form-group>
                    </div>
                    <div class="col-md-2">
                        <b-form-group label="Modelo do Veículo:" label-for="dataRastreio-motorista-modelo" id="lbl-motorista_modelo">
                            <b-form-input id="dataRastreio-motorista_modelo" type="text"
                                v-model="dataRastreio[0].motorista_modelo" disabled
                                class="textInput"/>
                        </b-form-group>
                    </div>
                    <div class="col-md-2">
                        <b-form-group label="Placa do Veículo:" label-for="dataRastreio-motorista-placa" id="lbl-motorista_placa">
                            <b-form-input id="dataRastreio-motorista_placa" type="text"
                                v-model="dataRastreio[0].motorista_placa" disabled
                                class="textInput"/>
                        </b-form-group>
                    </div>
                    <div class="col-md-2">
                        <b-form-group label="Booking:" label-for="dataRastreio-booking" id="lbl-booking">
                            <b-form-input id="dataRastreio-booking" type="text"
                                v-model="dataRastreio[0].transporte_booking" disabled
                                class="textInput"/>
                        </b-form-group>
                    </div>
                    <div class="col-md-2">
                        <b-form-group label="Data de Início:" label-for="dataRastreio-data_inicio" id="lbl-data_inicio">
                            <b-form-input id="dataRastreio-data_inicio" type="date"
                                v-model="dataRastreio[0].transporte_data_inicio" disabled
                                class="textInput"/>
                        </b-form-group>
                    </div>
                    <div class="col-md-2">
                        <b-form-group label="Data de Entrega:" label-for="dataRastreio-data_final" id="lbl-data_final">
                            <b-form-input id="dataRastreio-data_final" type="date"
                                v-model="dataRastreio[0].transporte_data_final" disabled
                                class="textInput"/>
                        </b-form-group>
                    </div>
                </div>
            </b-form>
            <hr>
            <div class="row justify-content-md-center">
                <div class="col-md-6">
                    <b-table hover striped class="text-center align-middle table" :items="logs" :fields="fields"></b-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'statuss',
    components: { PageTitle },
    data: function() {
        return {
            variantAlert: 'info',
            variantAlertDeny: 'danger',
            variantAlertSuccess: 'success',
            textNotify: '',
            dismissSecs: 5,
            dismissCountDown: 0,
            codigo: '',
            maxValue: '',
            curValue: '',
            rastreio: {},
            dataRastreio: [],
            statusRastreio: [],
            statuses: {},
            image: null,
            inSearch: false,
            logs: [],
            fields: [
                { key: 'titulo', label: 'Status', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'data', label: 'Data', sortable: true, formatter: 'formatData', thClass: 'tituloTabela', tdClass: 'fieldsTabela'}
            ]
        }
    },
    validations: {
        codigo: {
            required
        }
    },
    methods: {
        loadLogs(){
            axios.get(`${baseApiUrl}/backend/tableRastreio.php?rastreio=${this.codigo}`)
            .then(res => {
                this.logs = res.data
            })
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        popOver(event) {
            const offX = event.offsetX
            const offY = event.offsetY
            const totalX = document.getElementById('foto').width
            const totalY = document.getElementById('foto').clientHeight
            const pctX = (offX / totalX) * 100
            const pctY = (offY / totalY) * 100

            if(this.maxValue > 0){
                if( pctX > 7 && pctX < 13 ){
                    if( pctY > 30 && pctY < 70){
                        if(this.curValue < 1){
                            this.variantAlert = this.variantAlertDeny
                        } else {
                            this.variantAlert = this.variantAlertSuccess
                        }
                        this.textNotify = this.statuses[0].titulo
                        this.dismissCountDown = this.dismissSecs
                    }
                }
            }
            if(this.maxValue > 1){
                if( pctX > 17 && pctX < 23 ){
                    if( pctY > 30 && pctY < 70){
                        if(this.curValue < 2){
                            this.variantAlert = this.variantAlertDeny
                        } else {
                            this.variantAlert = this.variantAlertSuccess
                        }
                        this.textNotify = this.statuses[1].titulo
                        this.dismissCountDown = this.dismissSecs
                    }
                }
            }
            if(this.maxValue > 2){
                if( pctX > 27 && pctX < 33 ){
                    if( pctY > 30 && pctY < 70){
                        if(this.curValue < 3){
                            this.variantAlert = this.variantAlertDeny
                        } else {
                            this.variantAlert = this.variantAlertSuccess
                        }
                        this.textNotify = this.statuses[2].titulo
                        this.dismissCountDown = this.dismissSecs
                    }
                }
            }
            if(this.maxValue > 3){
                if( pctX > 37 && pctX < 43 ){
                    if( pctY > 30 && pctY < 70){
                        if(this.curValue < 4){
                            this.variantAlert = this.variantAlertDeny
                        } else {
                            this.variantAlert = this.variantAlertSuccess
                        }
                        this.textNotify = this.statuses[3].titulo
                        this.dismissCountDown = this.dismissSecs
                    }
                }
            }
            if(this.maxValue > 4){
                if( pctX > 47 && pctX < 53 ){
                    if( pctY > 30 && pctY < 70){
                        if(this.curValue < 5){
                            this.variantAlert = this.variantAlertDeny
                        } else {
                            this.variantAlert = this.variantAlertSuccess
                        }
                        this.textNotify = this.statuses[4].titulo
                        this.dismissCountDown = this.dismissSecs
                    }
                }
            }
            if(this.maxValue > 5){
                if( pctX > 57 && pctX < 63 ){
                    if( pctY > 30 && pctY < 70){
                        if(this.curValue < 6){
                            this.variantAlert = this.variantAlertDeny
                        } else {
                            this.variantAlert = this.variantAlertSuccess
                        }
                        this.textNotify = this.statuses[5].titulo
                        this.dismissCountDown = this.dismissSecs
                    }
                }
            }
            if(this.maxValue > 6){
                if( pctX > 67 && pctX < 73 ){
                    if( pctY > 30 && pctY < 70){
                        if(this.curValue < 7){
                            this.variantAlert = this.variantAlertDeny
                        } else {
                            this.variantAlert = this.variantAlertSuccess
                        }
                        this.textNotify = this.statuses[6].titulo
                        this.dismissCountDown = this.dismissSecs
                    }
                }
            }
            if(this.maxValue > 7){
                if( pctX > 77 && pctX < 83 ){
                    if( pctY > 30 && pctY < 70){
                        if(this.curValue < 8){
                            this.variantAlert = this.variantAlertDeny
                        } else {
                            this.variantAlert = this.variantAlertSuccess
                        }
                        this.textNotify = this.statuses[7].titulo
                        this.dismissCountDown = this.dismissSecs
                    }
                }
            }
            if(this.maxValue > 8){
                if( pctX > 87 && pctX < 93 ){
                    if( pctY > 30 && pctY < 70){
                        if(this.curValue < 9){
                            this.variantAlert = this.variantAlertDeny
                        } else {
                            this.variantAlert = this.variantAlertSuccess
                        }
                        this.textNotify = this.statuses[8].titulo
                        this.dismissCountDown = this.dismissSecs
                    }
                }
            }

        },
        loadStatuses() {
            this.$v.codigo.$touch()
            if(!this.$v.codigo.$error){
                axios.get(`${baseApiUrl}/backend/dadosRastreio.php?rastreio=${this.codigo}`)
                .then(res1 => {
                    this.dataRastreio = res1.data
                    this.dataRastreio[0].origem_end = this.dataRastreio[0].origem_logradouro + ', ' +
                        this.dataRastreio[0].origem_numero + ', ' + this.dataRastreio[0].origem_complemento + ', ' +
                        this.dataRastreio[0].origem_cidade + '-' + this.dataRastreio[0].origem_uf
                    this.dataRastreio[0].destino_end = this.dataRastreio[0].destino_logradouro + ', ' +
                        this.dataRastreio[0].destino_numero + ', ' + this.dataRastreio[0].destino_complemento + ', ' +
                        this.dataRastreio[0].destino_cidade + '-' + this.dataRastreio[0].destino_uf
                    axios.get(`${baseApiUrl}/backend/status.php`)
                    .then(res2 => {
                        this.maxValue = res2.data.length
                        this.statuses = res2.data
                    })

                    axios.get(`${baseApiUrl}/backend/statusRastreio.php?rastreio=${this.codigo}`)
                    .then(res3 => {
                        this.statusRastreio = res3.data
                        if (!res3.data.length) {
                            this.curValue = '0'
                        } else {
                            this.curValue = res3.data.length
                        }
                        
                        this.image = `${baseApiUrl}/frontend/src/assets/tracking/${this.maxValue}${this.curValue}.png`
                        this.loadLogs()
                    })
                })
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        reset() {
            this.rastreio = {}
            this.image = null
            this.$v.codigo.$reset()

        },
        formatData(value) {
            if(value !== ''){
                const arr = value.split('-')
                const y = arr[0]
                const m = arr[1]
                const d = arr[2]
                return `${d}/${m}/${y}`
            } else {
                return '---'
            }
        }
    },
    mounted() {
        let cod = this.$route.params.id
        if(cod === undefined){
            this.inSearch = true
        } else {
            this.inSearch = false
            this.codigo = cod
            this.loadStatuses()
            this.loadLogs()
        }
        this.image = null
        this.variantAlert = 'info'
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

.textInput {
    border: 1px solid rgb(220, 220, 220);
    outline: 0 !important;
    border-radius: 0px !important;
    background-color: transparent !important;
    font-size: 0.8rem !important;
}

.botaoInput {
    font-size: 0.8rem !important;
    border-radius: 0px !important;
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border: 1px solid #f57f6c !important;
}

.btn-size {
    width: 30px;
    height: 30px;
    border-radius: 0;
}

.text-custom {
    font-size: 0.8rem;
}

.actionsTabela {
    max-width: 30px;
    vertical-align: middle;
}

.fieldsTabela {
    vertical-align: middle !important;
    font-size: 0.8rem;
}

.tituloTabela {
    font-weight: normal;
    font-style: italic;
    font-size: 0.9rem;
}

label {
    font-size: 0.8rem;
}
</style>